import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../redux/slices/authSlice";
import { Input, Button, Form, Checkbox, Alert, Card } from "antd";
import "antd/dist/reset.css";
import image from '../../assets/ust-logo.png';
import "./Login.css"; 
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../../components/Footer/Footer";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);
  const [form] = Form.useForm();
  const [loginError, setLoginError] = useState(null);
  const location = useLocation();
  sessionStorage.setItem('APP_BASE_PATH',location.pathname.includes("/subapp")
  ? "/subapp":"");
  const basePath = sessionStorage.getItem('APP_BASE_PATH')

  // Handle login and connect with backend API
  const onFinish = async (values) => {
    try {
      const response = await dispatch(loginUser(values)).unwrap();
      localStorage.setItem("token", response.token);
      localStorage.setItem("userEmail", response.email);
      localStorage.setItem("firstLogin", response.firstLogin);
      
      if (response.roles.includes("SUPERUSER")) navigate(`${basePath}/superuser-dashboard`);
      else if (response.roles.includes("ADMINUSER")) navigate(`${basePath}/adminuser-dashboard`);
      else if (response.roles.includes("NORMALUSER") && response.firstLogin) {
        navigate(`${basePath}/change-password`);
      } else {
        navigate(`${basePath}/normaluser-dashboard`);
      }
    } catch (err) {
      setLoginError("Invalid email or password.");
    }
  };

  // Handle Forgot Password click
  const handleForgotPassword = () => {
    const email = form.getFieldValue("email"); // Get the entered email

    if (!email) {
      setLoginError("Please enter your email before clicking Forgot Password."); // Show error
      return;
    }

    navigate(`${basePath}/forgot-password`, { state: { email } }); // Pass email to ForgotPassword page
  };

  return (
    <div className="w-full login-container">
      <div className="left-section hidden lg:flex"></div>
      <div className="right-section flex justify-center items-center w-full px-6">
        <Card className="login-card w-full max-w-md">
          <div className="logo-container">
            <img src={image} alt="UST Logo" className="login-image" />
          </div>
          <h4 className="text-2xl font-semibold text-center whitespace-nowrap login-title">
            Login with your account
          </h4>
          {(loginError || error) && <Alert message={loginError || error} type="error" showIcon className="mb-4" />} 
          <Form form={form} name="login" initialValues={{ remember: true }} onFinish={onFinish}>
            <Form.Item name="email" rules={[{ required: true, message: "Enter Email!" }, { type: "email", message: "Enter a valid Email!" }]}>
              <Input placeholder="Email" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: "Enter password!" }]}>
              <Input.Password placeholder="Password" />
            </Form.Item>
            <Form.Item>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox className="custom-checkbox">Remember me</Checkbox>
              </Form.Item>
              <a className="float-right forgot-password" onClick={handleForgotPassword}>Forgot password?</a>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block className="custom-button" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
      <Footer />
    </div>
  );
};

export default Login;